import Vue from 'vue';

// Store reativo de estado de UI por linha, para listas virtualizadas (optimizedList /
// RecycleScroller). O scroller recicla/realoca instâncias de componente para a mesma
// linha lógica, então estado imperativo guardado na instância (ex.: `visible` setado
// via setPropValue) não sobrevive à troca de instância nem ao scroll.

// Aqui o estado mora FORA da instância, indexado por `listaId | rowId(_id) | cpId | prop`.
// Como é `Vue.observable`, o getProp lê reativamente: qualquer instância do pool que
// renderize a linha reflete o valor certo, e uma gravação re-renderiza sozinha.
const store = Vue.observable({ props: {} });

// Props de UI por linha que devem sobreviver à reciclagem/scroll. Só faz sentido
// persistir o que é lido de volta via `getProp` (dos wrappers `...Interno`) — hoje é
// `visible`. Props internas do componente (value, disabled, fieldState, maskOptions)
// são lidas direto na instância, não pelo getProp, então persisti-las aqui não teria
// efeito. Para cobrir uma nova prop, adicione-a aqui E garanta que ela seja lida via
// getProp no componente correspondente.
export const PERSISTED_ROW_PROPS = new Set(['visible']);

const chave = (listaId, rowId, cpId, nome) => `${listaId}|${rowId}|${cpId}|${nome}`;

export function setRowUiProp(listaId, rowId, cpId, nome, valor) {
    if (listaId == null || rowId == null || cpId == null) return;
    Vue.set(store.props, chave(listaId, rowId, cpId, nome), valor);
}

export function getRowUiProp(listaId, rowId, cpId, nome) {
    if (listaId == null || rowId == null || cpId == null) return undefined;
    return store.props[chave(listaId, rowId, cpId, nome)];
}

// Limpa todo o estado de uma lista (chamar no beforeDestroy da ClicList e dataRefresh) 
// para não acumular chaves indefinidamente.
export function clearRowUiProps(listaId) {
    if (listaId == null) return;
    const prefixo = `${listaId}|`;
    Object.keys(store.props).forEach((k) => {
        if (k.startsWith(prefixo)) Vue.delete(store.props, k);
    });
}

export default { setRowUiProp, getRowUiProp, clearRowUiProps };
